import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import Toggle from '@r1-frontend/ui-react/components/controls/Toggle';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { setInitialGroupKey } from '~/src/store/actions/filteredBundles';

export type TMenuItem = {
    route?: string,
    text: string,
    action?: () => void,
}

interface IProps {
    items: TMenuItem[],
    activeItem: number,
    disabled?: boolean,
    activeDefaultTabByTariffs?: TMenuItem,
    isDifferentColorText?: boolean,
    colorTab?: string,
}

const FilterMenu: React.FC<IProps> = ({
    items,
    activeItem,
    disabled = false,
    activeDefaultTabByTariffs,
    isDifferentColorText = true,
    colorTab,
}): JSX.Element => {

    const dispatch = useDispatch();

    const tabFlat = 'Для квартиры';
    const toggleLabels = useMemo(() => ({ leftText: items[0]['text'], rightText: items[1]['text'] }), [items]);
    const labels = useMemo<Array<string>>(() => Object.values(toggleLabels), [toggleLabels]);

    const [label, setLabel] = useState<string>(
        activeDefaultTabByTariffs
            ? activeDefaultTabByTariffs['text']
            : activeItem === 0
                ? labels[0]
                : labels[1],
            );

    const [itemMenu, setItem] = useState<TMenuItem>(items.filter(item => item['text'] === label)[0]);

    useEffect(() => {
        dispatch(setInitialGroupKey(activeItem ? 'village' : 'city'));

        const currentItem = items.filter((item: TMenuItem) => item['text'] !== label)[0];
        setItem(currentItem);

        if (activeDefaultTabByTariffs && activeDefaultTabByTariffs['text'] !== tabFlat && disabled) {
            activeDefaultTabByTariffs.action?.();
        }
    }, [label]);

    const onMenuItemClick = useCallback(() => {
        const [toggledLabel] = labels.filter(item => item !== label);
        setLabel(toggledLabel);

        if (itemMenu && itemMenu.action && !disabled) {
            itemMenu.action();
        }
    }, [disabled, itemMenu, label, labels]);

    return (
        <Toggle
            textsValues={toggleLabels}
            isDisabled={disabled}
            onChangeCallback={() => onMenuItemClick()}
            fontSize={FONTS.S}
            activeTab={label}
            data-test='toggle-container'
            isDifferentColorText={isDifferentColorText}
            colorTab={colorTab}
        />
    );
};

export default FilterMenu;
